import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../../localization/react'
import type { Invoice } from '../InvoiceHistory.types'

import MobileInvoiceCard from './MobileInvoiceCard'

interface Props {
  invoices: Array<Invoice>
}

const MobileInvoiceCards = ({ invoices }: Props) => {
  return (
    <Stack gap={2} display={{ xs: 'flex', md: 'none' }}>
      {invoices.length ? (
        invoices.map((invoice) => <MobileInvoiceCard key={invoice.number} invoice={invoice} />)
      ) : (
        <Text textAlign="center">
          <Localized id="invoice-history-table-text-no-invoices" />
        </Text>
      )}
    </Stack>
  )
}

export default MobileInvoiceCards
